<template>
  <div class="list-table-ware-house">
    <!-- <el-table
      v-loading="loading"
      :data="tableData"
      class="tran_table"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
      />
      <el-table-column
        v-for="(item,index) in COLUMN"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        v-bind="item"
        :min-width="item.minWidth"
        :fixed="item.fixed || false"
      >
        <template slot-scope="scope">
          <span v-if="item.prop === 'warehouseTransferRuleListText'">
            {{ formatRouter(scope.row.warehouseTransferRuleList) }}
          </span>
          <span v-if="item.prop === 'warehouseTransferRuleListContract'">
            {{ formatContract(scope.row.warehouseTransferRuleList) }}
          </span>
          <template v-else-if="item.prop==='active'" fixed>
            <el-button
              type="text"
              size="small"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleEdit(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleRecord(scope.row)"
            >
              变更记录
            </el-button>
          </template>
          <template v-else>
            <span v-text="item.formatter ? item.formatter(scope.row) : scope.row[item.prop]" />
          </template>
        </template>
      </el-table-column>
    </el-table> -->
    <div
      v-for="(item, index) in tableData"
      :key="index"
      class="list-table-ware-house-item"
    >
      <div class="ware-house-item-header">
        <div class="header-left">
          <div class="header-left-tag">
            <el-tag type="info">
              {{ warehouseOptions[item.type] }}
            </el-tag>
          </div>
          <div class="header-left-operator">
            <span>操作人：</span>
            <span>{{ item.updateUserName || item.createUserName }}</span>
          </div>
          <div class="header-left-time">
            <span>更新时间：</span>
            <span>{{ $dateFormatter(item.updateTime || item.createTime) }}</span>
          </div>
        </div>
        <div class="header-right">
          <el-button
            type="danger"
            plain
            size="small"
            @click="handleDelete(item)"
          >
            删除
          </el-button>
          <el-button
            type="primary"
            plain
            size="small"
            @click="handleRecord(item)"
          >
            变更记录
          </el-button>
          <el-button
            type="primary"
            plain
            size="small"
            @click="handleEdit(item)"
          >
            编辑
          </el-button>
        </div>
      </div>
      <div class="ware-house-item-main">
        <div class="ware-house-item-main-box">
          <!-- <div>
            {{ formatRouter(item.warehouseTransferRuleList) }}
          </div>
          <div>
            {{ formatContract(item.warehouseTransferRuleList) }}
          </div> -->
          <div class="ware-house-item-contract">
            <div
              v-for="c in contractList(item.warehouseTransferRuleList)"
              :key="c.contractCode"
              class="contract-self"
            >
              <div class="contract-self-common contract-self-name">
                <span :class="[`contract-self-name-${c.contractType}`]">{{ c.contractType === 'consignor' ? '货主合同' : '仓储合同' }}</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="c.contractName"
                  placement="top"
                  popper-class="contract-self-common-tip"
                >
                  <div slot="content">
                    {{ c.contractName }}<br>({{ c.contractCode }})
                  </div>
                  <span>{{ c.contractName }}</span>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="复制"
                  placement="top"
                  popper-class="contract-self-common-tip"
                >
                  <span @click="handleCopy(c, 'contract')">
                    <i class="el-icon-document-copy" />
                  </span>
                </el-tooltip>
              </div>
              <div class="contract-self-common contract-self-project">
                <span>运营项目</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="c.projectName"
                  placement="top"
                  popper-class="contract-self-common-tip"
                >
                  <span>{{ c.projectName }}</span>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="复制"
                  placement="top"
                  popper-class="contract-self-common-tip"
                >
                  <span @click="handleCopy(c)">
                    <i class="el-icon-document-copy" />
                  </span>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="ware-house-item-line">
            <div class="line-box">
              <div
                v-for="l in infoNodeList(item)"
                :key="l.id"
                class="line-icon"
              >
                <img src="https://oss-public.yunlizhi.cn/2040/20240103/j1odwiTw.png" alt="">
              </div>
              <!-- <div class="line-self"
                :style="{
                  width: (infoNodeList(item).length - 1) * 318.67 + 'px',
                }"
              /> -->
              <div class="line-self" />
            </div>
          </div>
          <div class="ware-house-item-info">
            <div
              v-for="(i, iIndex) in infoNodeList(item)"
              :key="i.id"
              class="info-self-box"
            >
              <div class="info-self">
                <span v-if="i.type !== 'none'" :class="['item-info-type', `item-info-type-${i.type}`]">{{ i.type === 'customer' ? '客户' : '仓库' }}</span>
                <span class="item-info-name">{{ i.name }}</span>
                <span class="item-info-code">{{ i.code }}</span>
              </div>
              <div v-if="iIndex === infoNodeList(item).length - 1" class="info-self">
                <span class="item-info-type item-info-type-storeCustomer">仓货主</span>
                <span class="item-info-name">{{ item.originalCustomerName }}</span>
                <span class="item-info-code">{{ item.originalCustomerCode }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddRollOverWareHouse
      ref="AddRollOverWareHouse"
      :customers-detail="customersDetail"
      @refer="hanldeRefer"
    />
    <editRecord ref="editRecordRef" />
  </div>
</template>

<script>
import { batchRemove } from '@/api/configure/ownerRule';
import { localStorageGet } from '@/utils/localStorage';
import { USER } from '@/constant/storage';
import {
  COLUMN, warehouseOptions,
} from '../constant';
import AddRollOverWareHouse from './addRollOverWareHouse.vue';
import editRecord from './editRecord.vue';

export default {
  name: 'ListTable',
  components: {
    AddRollOverWareHouse,
    editRecord,
  },
  props: {
    tableData: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    customersDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      warehouseOptions,
      COLUMN,
      userInfo: localStorageGet(USER),
      multipleSelection: [],
    };
  },
  computed: {
    formatRouter() {
      return (list = []) => {
        const routers = list.map((item) => item.tenantName);
        return routers.join(' ➝ ');
      };
    },
    formatContract() {
      return (list = []) => {
        const newData = list.filter((t) => t.contractName).map((t) => `${t.contractName}(${t.contractCode})`);
        return newData.join(' ➝ ');
      };
    },
    contractList() {
      return (list = []) => {
        const newData = list.filter((t) => t.contractCode).map((t) => {
          const warehouseTransferRuleList = {
            ...t,
            contractType: t.contractCode.startsWith('H') ? 'consignor' : 'store',
          };
          return warehouseTransferRuleList;
        });
        return newData;
      };
    },
    infoNodeList() {
      return (item = {}) => {
        const customer = {
          type: 'customer',
          name: item.customerName,
          code: item.customerCode,
        };
        const warehouseTransferRuleList = item?.warehouseTransferRuleList?.map((w, wIndex) => {
          const info = {
            type: wIndex === item.warehouseTransferRuleList.length - 1 ? 'store' : 'none',
            name: w.tenantName,
            code: w.tenantId,
          };
          return info;
        });
        return [
          customer,
          ...warehouseTransferRuleList,
        ];
      };
    },
  },
  methods: {
    create() {
      this.$refs.AddRollOverWareHouse.init();
    },
    handleEdit(row) {
      this.$refs.AddRollOverWareHouse.init(row, true);
    },
    handleRecord(row) {
      // 变更记录
      this.$refs.editRecordRef.show(row);
    },
    hanldeRefer() {
      this.$emit('refresh');
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async handleBatchDelete() {
      if (this.multipleSelection.length > 0) {
        const ids = this.multipleSelection.map((res) => res.id);
        const data = {
          ids,
          operateUserId: this.userInfo.userId,
          operateUserName: this.userInfo.realName,
        };
        await batchRemove(data);
        this.$message.success('删除成功');
        this.hanldeRefer();
      } else {
        this.$message.warning('请选择需要删除的数据');
      }
    },
    async  handleDelete(row) {
      this.$confirm('是否确定删除此链路?', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const data = {
          ids: [row.id],
          operateUserId: this.userInfo.userId,
          operateUserName: this.userInfo.realName,
        };
        await batchRemove(data);
        this.$message.success('删除成功');
        this.hanldeRefer();
      });
    },
    async handleCopy(s, type) {
      console.log('handleCopy--', s);
      await this.$copyText(type === 'contract' ? `${s.contractName}(${s.contractCode})` : `${s.projectName}`);
      this.$message({
        type: 'success',
        message: '复制成功',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-box{
  text-align: left;
  margin-bottom: 16px;
}
.tran_table{
  ::v-deep .el-table__header-wrapper{
    .el-table__cell{
      background-color: #F5F7FA !important;
    }
  }
}
.list-table-ware-house {
  display: flex;
  flex-wrap: wrap;
  // align-content: flex-start;
  // padding: 16px;
  gap: 16px;
  flex-direction: column;
  .list-table-ware-house-item {
    padding: 15px 20px 16px;
    border-radius: 8px;
    border: 1px solid var(---el-border-color-light, #E6EAF0);
    background: var(---el-color-white, #FFF);
    flex-grow: 0;
    flex-shrink: 0;
    width: 100%;
    box-sizing: border-box;
    ::v-deep .el-tag.el-tag--info {
      background-color: var(---el-border-color-light, #E6EAF0) !important;
      border-color: #d1e9ff !important;
      color: #1890ff !important;
      border-radius: 2px !important;
      color: var(---el-text-color-regular, #505762) !important;
      text-align: center !important;
      font-family: PingFang SC !important;
      font-size: 12px !important;
      font-style: normal !important;
      font-weight: 400 !important;
      line-height: 20px !important;
    }
    .ware-house-item-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      .header-left {
        display: flex;
        align-items: center;
        gap: 16px;
        .header-left-operator > span , .header-left-time > span {
          color: var(---el-text-color-secondary, #7E8694);
          /* 标准/400/B1-14-Base */
          font-family: PingFang SC;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 157.143% */
          letter-spacing: -0.01px;
        }
        .header-left-operator > span:last-child, .header-left-time > span:last-child {
          color: var(---el-text-color-primary, #1C2026);
        }
      }
      .header-right {
        ::v-deep .el-button--danger.is-plain {
          color: #f56c6c;
          background: #fef0f000;
          border-color: #fbc4c4;
        }
      }
    }
  }
  .ware-house-item-main {
    // margin-top: 59px;
    padding-top: 59px;
    display: flex;

    overflow-x: auto;
    overflow-y: hidden;
    // 火狐滚动条直接隐藏 火狐滚动条不能修改样式
    // auto  dark  light     red #00f  第一个颜色为滚动条的颜色， 第二个颜色为滚动条轨道的颜色
    scrollbar-color: #C1C1C1 rgba(0, 0, 0, 0.1);
    scrollbar-track-color: #C1C1C1;
    -ms-scrollbar-track-color: transparent;
    // 滚动条变细，为none时隐藏滚动条   auto thin  none  66px
    scrollbar-width: thin;
    -ms-scrollbar-width: thin;

    &::-webkit-scrollbar {
      // width: 0px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      // background: rgba(0, 0, 0, 0.1);
      // border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgb(193, 193, 193, 0.6);
      transition: all 0.25s ease-in-out;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: rgb(193, 193, 193, 1);
    }
  }
  .ware-house-item-main-box {
    flex-shrink: 0;
    flex-grow: 1;
    .ware-house-item-contract {
      display: flex;
      justify-content: space-around;
      padding: 0 102px 0;
      margin-bottom: 22px;
      gap: 23px;
      .contract-self {
        position: relative;
        flex-shrink: 0;
        flex-grow: 0;
        width: 296px;
        height: 74px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 12px;
        border-radius: 6px;
        background: var(---el-color-white, #FFF);
        border-top: 1px solid var(---el-border-color-light, #E6EAF0);
        // box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.08);
        box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.08), 0px 16px 24px rgba(0, 0, 0, 0.04), 0px 6px 30px rgba(0, 0, 0, 0.05);
        .contract-self-common {
          display: flex;
          align-items: center;
          > span:nth-child(1) {
            margin-right: 4px;
            flex-shrink: 0;
            color: var(---Purple6-Normal, #6B4FBB);
            text-align: center;

            /* 标准/500/S1-12-Extra Small */
            font-family: PingFang SC;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px; /* 166.667% */
            padding: 0 4px;
            border-radius: 4px;
            background: var(---Purple1-Background, #F0EDF8);
          }
          .contract-self-name-store {
            background: var(---el-color-action-light-10, #E8F5FF) !important;
            color: var(---el-color-action-light-5, #1677FF) !important;
          }
          > span:nth-child(2) {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            color: var(---el-text-color-primary, #1C2026);
            text-align: left;
            text-overflow: ellipsis;

            /* 标准/500/S1-12-Extra Small */
            font-family: PingFang SC;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px; /* 166.667% */
          }
          > span:nth-child(3) {
            margin-left: 6px;
            flex-shrink: 0;
            cursor: pointer;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            background: var(---el-color-white, #FFF);
            > img {
              display: block;
              width: 14px;
              height: 14px;
            }
            .el-icon-document-copy {
              font-weight: bold;
              font-size: 14px;
              color: #1C2026;
            }
          }
          > span:nth-child(3):hover {
            background: var(---el-color-primary-opacity10, rgba(5, 158, 132, 0.10));
            .el-icon-document-copy {
              color: #059E84;
            }
          }
        }
        .contract-self-common {
          > span:nth-child(2):hover {
            color: var(---el-color-primary, #059E84) !important;
          }
        }
        .contract-self-project {
          > span:nth-child(1) {
            color: var(---el-text-color-regular, #505762);
            background: var(---el-border-color-lighter, #F0F2F5);
          }
        }
      }
      .contract-self::after {
        position: absolute;
        content: '';
        display: inline-block;
        width: 0;
        height: 0;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
        transform: translateY(50%);
        border-top: 6px solid #FFF;
        border-right: 6px solid transparent;
        border-left: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-radius: 0px;
        z-index: 12;
      }
    }
    .ware-house-item-line {
      padding: 0 78px 0;
      margin-bottom: 8px;
      gap: 294.67px;
      .line-box {
        position: relative;
        display: flex;
        justify-content: space-between;
        gap: 294.67px;
        .line-icon {
          position: relative;
          z-index: 10;
          > img {
            display: block;
            width: 24px;
            height: 24px;
            position: relative;
            z-index: 10;
          }
        }
        .line-self {
          position: absolute;
          left: 12px;
          bottom: calc(50% - 2px);
          transform: translateY(-50%);
          width: calc(100% - 24px);
          border-bottom: 2px dashed var(---el-border-color-base, #CDD2DA);
          z-index: 0;
        }
      }
    }
    .ware-house-item-info {
      display: flex;
      gap: 138.67px;
      padding-bottom: 8px;
      justify-content: space-between;
      .info-self-box {
        display: flex;
        flex-direction: column;
        gap: 12px;
        flex-grow: 0;
        flex-shrink: 0;
      }
      .info-self {
        display: flex;
        width: 180px;
        padding: 8px;
        box-sizing: border-box;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 4px;
        width: 180px;
        flex-grow: 0;
        flex-shrink: 0;
        border-radius: 4px;
        background: var(---el-color-normal-bg, #F6F7F9);
        .item-info-type {
          border-radius: 2px;
          background: var(---el-color-warning, #FF7D00);
          padding: 0 8px;
          color: var(---el-color-white, #FFF);
          text-align: center;
          font-family: PingFang SC;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px; /* 166.667% */
        }
        .item-info-type-store {
          background: var(---el-color-action-light-5, #1677FF);
        }
        .item-info-type-storeCustomer {
          background: var(---el-color-success, #00B42A);
        }
        .item-info-name {
          color: var(---el-text-color-primary, #1C2026);
          text-align: center;
          /* 标准/500/B1-14-Base */
          font-family: PingFang SC;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 22px; /* 157.143% */
          letter-spacing: -0.01px;
        }
        .item-info-code {
          color: var(---el-text-color-secondary, #7E8694);
          text-align: center;
          font-family: PingFang SC;
          font-size: 12px;
          font-style: normal;
          font-weight: 600;
          line-height: 20px; /* 166.667% */
          letter-spacing: -0.01px;
        }
      }
    }
  }
}
</style>
